<template>
  <div class="question">
    <div class="main-container">
      <section class="app-main">
        <div class="container" ref="container">
          <div class="main-background">
            <img style="width: 100%; height: 100%; object-fit: cover" :src="question['bg_img']" />
          </div>
          <div class="title">
            <span style="font-size: 1.8rem">{{ question["name"] || "-" }}</span>
            <span class="ct">答题倒计时：</span>
            <span>{{ timeLable }}</span>
          </div>

          <!--  -->
          <div class="main">
            <div class="sub-title">
              <span style="font-size: 1.5rem">{{
              topic[activeKey]["name"]
            }}</span>
              <div class="progress">
                <i class="el-icon-time"></i>
                <span>当前进度:</span>
                <el-progress :percentage="percentage_method" :color="customColor" style="width: 10rem"></el-progress>
              </div>
            </div>
            <!-- 放大镜 -->
            <div class="zoom" v-for="(item, index) in topic[activeKey]['zoomIn']" :key="index" :style="{
              left: item['left'],
              top: item['top'],
            }">
              <img src="../../assets/img/zoomIn.png" @click="showKeyWords(item['modalType'], item['url'])" />
            </div>
            <div class="choose" v-if="topic[activeKey]['choose'] != undefined">
              <div class="choose-title">
                {{ topic[activeKey]["choose"]["title"] }}
              </div>
              <!-- 多选 -->
              <div class="choose-option" v-if="topic[activeKey]['choose']['type'] == 'choose'">
                <el-checkbox-group v-model="ckeckList">
                  <div class="option" v-for="(item, index) in topic[activeKey]['choose'][
              'chooseOption'
              ]" :key="index">
                    <el-checkbox :label="item.value">{{
              item.name
            }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>

              <!-- 单选 -->
              <div class="choose-option" v-if="topic[activeKey]['choose']['type'] == 'radio'">
                <el-radio-group v-model="radio">
                  <div class="option" v-for="(item, index) in topic[activeKey]['choose'][
              'chooseOption'
            ]" :key="index">
                    <el-radio :label="item.value">{{ item.name }}</el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <div v-if="activeKey == 6" class="operate">
              <div class="box" @click="inOpen"
                style="top: 59.9289%; left: 57.4%; height: 8.69565%; width: 6.2%; border: none; background: url(&quot;https://res.hmxfkj.cn/data/new/rotate.png&quot;) 0% 0% / 100% 100% no-repeat; scale: 0.6;">
              </div>
              <div class="box" @click="inClose"
                style="top: 59.5217%; left: 65.4%; height: 8.69565%; width: 6.2%; border: none; background: url(&quot;https://res.hmxfkj.cn/data/new/rotate.png&quot;) 0% 0% / 100% 100% no-repeat; scale: 0.6; transform: rotateY(180deg);">
              </div>
              <div class="box a" @click="outOpen"
                style="top: 61.4743%; left: 17.9%; height: 8.69565%; width: 6.2%; border: none; scale: 0.6; background: url(&quot;https://res.hmxfkj.cn/data/new/rotate.png&quot;) 0% 0% / 100% 100% no-repeat;">
              </div>
              <div class="box a" @click="outClose"
                style="top: 61.4743%; left: 28.3%; height: 8.69565%; width: 6.2%; border: none; background: url(&quot;https://res.hmxfkj.cn/data/new/rotate.png&quot;) 0% 0% / 100% 100% no-repeat; scale: 0.6; transform: rotateY(180deg);">
              </div>
            </div>

          </div>

          <!-- 按钮栏  -->
          <div class="toolbar">
            <div class="toolbar-content">
              <div class="btns">

                <el-button type="primary tips" v-if="type != 'opera'" @click="onTips">提示</el-button>

                <div class="right-btn">
                  <el-button v-if="activeKey == 6 && nextShow" type="primary" ref="next" @click="nextStep">下一步</el-button>
                  <el-button type="primary" @click="onSubmit" :disabled="subDisabled">提交</el-button>
                  <el-button type="primary" @click="reset">重做</el-button>
                  <el-button type="primary" @click="goBack">返回</el-button>
                </div>
              </div>
            </div>
          </div>


          <tips :visible="tipsVisible" :tips="topic[activeKey]['tips']" :close="() => (tipsVisible = false)"></tips>
          <!--  -->
          <tabs ref="tabs" v-if="activeKey == 1" :visible="tipsVisible" :urls="urls" v-on:aa="changebg"></tabs>
          <stable ref="stable" :first="first" :water="water" :visible="stableVisible"
            :close="() => (stableVisible = false)"></stable>
          <pressguage ref="pressguage" :visible="pressVisible" :echartsData="echartsData"
            :close="() => (pressVisible = false)"></pressguage>
          <enddevice ref="enddevice" auto="auto" :isClose=true :visible="enddeviceVisible"
            :close="() => (enddeviceVisible = false)"></enddevice>
          <imgDialog v-if="activeKey >= 4" ref="imgDialog" :visible="imgVisible" :url="url"
            :close="() => (imgVisible = false)">
          </imgDialog>

          <div v-if="activeKey == 6" class="plugins">
            <div style="top: 53.5383%; left: 25.95%; height: 11.3123%; width: 0.8%; position: absolute; z-index: 2;">
              <div class="handles" :class="isOutOpen" result="" scence-idx="0"></div>
            </div>
            <div 
              style="top: 52%; left: 63.1%; height: 11.4625%; width: 2.1%; position: absolute; z-index: 2;">
              <div  class="handled" result="" scence-idx="0">
                <div class="handle one open":class="isInOpen"></div>
                <div  class="handle two open" :class="isInOpen"></div>
              </div>
            </div>
            <div 
              style="top: 90.0565%; left: 28.3%; height: 9.64822%; width: 6%; position: absolute; z-index: 2;">
              <div   class="water" :class="isWater"result="" scence-idx="0"></div>
            </div>
            <div
              style="position: absolute; left: 70%; top: 50%; transform: translateY(-50%); width: 18.75rem; height: 18.75rem; z-index: 999999;">
              <div class="timer">
                <div class="time" :class="isTime"><img :src="require('@/assets/img/wei15/15-3-3.png')"
                    style="width: 18.75rem;">
                  <div class="count" style="font-family: electronicFont">08:00:00</div>
                </div>
              </div>
            </div>
          </div>





        </div>
      </section>
    </div>


    <!--音频  -->
    <audio v-show="false" ref="audio" controls src="" preload="metadata" @play="handleMusicPlay"
      @ended="handleMusicEnded">
      <source src="" />
    </audio>
    <!--   音频2 按钮、放大、放小-->
    <audio v-show="false" ref="audio2" controls src="" preload="metadata">
      <source src="" />
    </audio>
    <!--    音频3 需要一直循环的声音-->
    <audio v-show="false" ref="audio3" controls src="" preload="metadata">
      <source src="" />
    </audio>
    <Baywindow></Baywindow>
  </div>
</template>

<script>

import Tabs from "@/component/tabs";
import tips from "../../component/tips.vue";
import stable from '../../component/stable.vue'
import pressguage from "../../component/pressguage.vue";
import enddevice from "../../component/enddevice.vue"
import imgDialog from "../../component/img.vue";
import screenfull from "screenfull";
import { arraysAreEqual } from "@/util/arr.js";
import Baywindow from "@/components/Baywindow.vue";

export default {
  data() {
    return {
      fullscreenFlag: false,
      question: null,
      topicBk: null,
      // 进度条
      percentage: 20,
      customColor: "#409eff",
      customColors: [{ color: "#f56c6c", percentage: 20 }],
      stableVisible: false,
      tipsVisible: false,
      pressVisible: false,
      enddeviceVisible: false,
      imgVisible: false,
      cities: [],
      topic: [],
      ckeckList: [],
      radio: null,
      activeKey: 0,
      // 答案集合
      ansObj: {},
      six: {},
      urls: [],
      trans: false,
      turn: false,
      down: false,
      open: false,
      move: false,
      auto: false,
      water: false,
      nextShow: true,
      nextKey:0,
      isWater: 'hide',
      isTime: 'hide',
      isInOpen: 'open',
      isOutOpen: 'close',
      tool: 0,
      subDisabled: false, //提交按钮, 是否点击
      print: false,
      type: 'viewr',
      timer: null,
      timeLable: '00:00',
      count: 0,
      randomNum: 0,
      apiId: '100017',
      totalScore:0,
      first: 0,
      echartsData: 0.25,
      url: '',
    };
  },
  components: {
    Tabs,
    tips,
    stable,
    pressguage,
    enddevice,
    imgDialog,
    Baywindow
  },
  computed: {
    percentage_method() {
      return parseInt(this.percentage * (this.activeKey + 1));
    },
  },
  created() {
    this.type = this.$route.query.type
    this.count = this.$route.query.count
    let { question } = require("../../api/wei100017");
    this.question = question;

    this.topic = question["topic"];
    this.play(this.topic[0]["audio"]);

    this.urls = question["tab"].filter((value, index, array) => {
      if (this.topic[0]["tab"].indexOf(index) >= 0) {
        return array[index];
      }
    });
    this.question["bg_img"] = this.urls[0].src;
    this.percentage = 100 / this.topic.length;
    this.first = Math.floor(Math.random() * 2);
    this.six = _.cloneDeep(this.topic[6]);
    console.log(this.six)

    screenfull.toggle()

    this.type = this.$route.query.type
    this.count = this.$route.query.count
    if(this.type !== 'viewr'){
      this.timeCountSetInterVal()
    }

  },
  mounted() {
    // 监听全屏变化
    screenfull.onchange(() => {
      this.isFullscreen = screenfull.isFullscreen
    })

  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer);
    this.timer=null;
    next(true);
  },
  methods: {
    nextStep() {

      this.topic[this.activeKey]['choose'] = this.topic[this.activeKey]['next']
      this.topic[this.activeKey]['tips'] = this.topic[this.activeKey]['nextTips']
      this.nextShow = false
      this.nextKey++;
    },
    inOpen() {
      this.isInOpen = 'open'
      if(this.activeKey===6&&this.nextKey===1){
        this.isTime = 'show'
      }
    },
    inClose() {
      this.isInOpen = 'close'

    },
    outOpen() {
      this.isOutOpen = 'open'
      this.isWater = 'show'

    },
    outClose() {
      this.isOutOpen = 'close'
      this.isWater = 'hide'
    },
    timeCountSetInterVal() {
      if (this.timer) return
      this.timer = setInterval(() => {
        this.count = this.count - 1
        this.fomatTime(this.count)
        if (this.count <= 0) {
          clearInterval(this.timer)
          this.timer = null

          let ids = sessionStorage.getItem('wids') ? JSON.parse(sessionStorage.getItem('wids')) : []
          ids.push(this.apiId)
          sessionStorage.setItem('wids', JSON.stringify(ids))
          window.sessionStorage.setItem("topic", JSON.stringify(this.topic));
          window.sessionStorage.setItem("ansObj", JSON.stringify(this.ansObj));
          this.$router.replace("/result");
          this.reset();
          this.restAll();
        }
      }, 1000)
    },
    fomatTime(totalSeconds) {
      // ?️ 获取完整分钟数
      const minutes = Math.floor(totalSeconds / 60);
      // ?️ 获得剩余的秒数
      const seconds = totalSeconds % 60;
      // ✅ 格式化为 MM:SS
      if (totalSeconds <= 0) {
        this.timeLable = '00:00'
      } else {
        this.timeLable = `${this.padTo2Digits(minutes)}分:${this.padTo2Digits(seconds)}秒`;
      }
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    },
    turnClose() {
      this.turn = this.$refs.front.turn;
      if (this.turn) {

      } else {
        this.$refs.audio2.pause();
        this.$refs.audio3.pause();
      }
    },
    selectTool() {
      this.tool = this.$refs.tools.tool;

    },
    changebg(url) {
      this.question["bg_img"] = url.src;
      this.topic[this.activeKey]["zoomIn"] = url.zoomIn;
      this.auto = this.$refs.stable.auto
      this.water = !this.$refs.enddevice.isCloseFn
      // console.log(this.water);

    },
    openWindow(val) {
      if (val == 0) {
        this.open = true;
      }
      if (val == 2) {
        this.open = false;
      }
    },
    upDown(val) {
      if (val == "down") {
        this.down = true;
      } else {
        this.down = false;
      }
      this.play2('12-6-2挡烟垂壁上升声.mp3')
    },
    async play(val) {
      if (!val) return;
      let music = new Audio();
      // 这里获取播放路径
      music = require(`../../assets/audio/${val}`);

      this.$nextTick((res) => {
        this.$refs.audio.src = music;
        let audio = this.$refs.audio;
        audio.load();
        audio.play();
      });
    },
    play2(val) {
      if (!val) return;
      let music = new Audio();
      // 这里获取播放路径 
      music = require(`../../assets/audio/${val}`);

      this.$nextTick((res) => {
        this.$refs.audio2.src = music;
        let audio = this.$refs.audio2;
        audio.load();
        audio.play();
      });
    },
    play3(val, loop = false, play = "play") {
      if (play === "stop") {
        this.$refs.audio3.pause();
      }
      if (!val) return;
      let music = new Audio();
      // 这里获取播放路径 
      music = require(`../../assets/audio/${val}`);

      this.$nextTick((res) => {
        this.$refs.audio3.src = music;
        let audio = this.$refs.audio3;
        audio.loop = loop;
        audio.load();
        audio.play();

      });
    },

    handleMusicPlay() {
      // this.subDisabled = true;
    },
    handleMusicEnded() {

      // this.subDisabled = false;

    },
    goBack() {
      this.$router.go(-1);
    },
    showKeyWords(type, url = '') {
      if (type == 'stable') {
        this.stableVisible = true;
      }
      if (type == 'press') {
        this.pressVisible = true;
      }
      if (type == 'enddevice') {
        this.enddeviceVisible = true;
      }
      if (type == 'img') {
        this.imgVisible = true;
        this.url = url;
      }


      // this.pressVisible = true; 


      this.play2("zoomout.mp3");
    },
    onTips() {
      this.tipsVisible = !this.tipsVisible;
      this.play2("zoomout.mp3");
    },
    onSubmit() {


      if (this.activeKey == this.topic.length) return;
      // 多选
      if (this.question.topic[this.activeKey]["type"] == "check") {
        // if (this.ckeckList.length == 0) return;
        // 判断两个数组全等
        // let ans = this.question.topic[this.activeKey]["choose"]["ans"];
        // let ckeckList = this.ckeckList.filter(item => item != null)
        // console.log(ans,ckeckList,'[[[]]]')
        // this.ansObj[this.activeKey] = arraysAreEqual(ans, ckeckList);
      }
      // 单选 
      if (this.question.topic[this.activeKey]["type"] == "radio") {

      }


      let res = false;
      switch (this.activeKey) {
        case 0:
          if (this.first == this.radio) {
            res = true;
          }

          break;
        case 1:
          if (this.radio == 0) {
            res = true;
          }
          break;
        case 2:
          if (this.radio == 0) {
            res = true;
          }

          break;
        case 3:
          if (this.radio == 0) {
            res = true;
          }

          break;
        case 4:
          let ans = this.question.topic[this.activeKey]["choose"]["ans"]
          console.log(ans)
          let ckeckList = this.ckeckList.filter(item => item != null)
          console.log(ckeckList)
          res = arraysAreEqual(ans, ckeckList);
          console.log(res)
          break;
        case 5:
          console.log(this.radio == 1)
          if (this.radio == 1) {
            res = true;
          }
          this.topic[6]['choose'] = {
            title: "请考生按要求对消防水箱进行泄水。 ", //选项名字
            type: "action",
            chooseOption: [

            ],
          }
          this.topic[6]['tips'] = {
            correctAnswer: "按要求操作即可",
            correctOperation: [
              { step: "1、消防水箱的进水阀和泄水阀上均有2个箭头符号（一个逆时针、一个顺时针）" },
              { step: "2、先点击进水阀的顺时针箭头符号，关闭进水阀（阀杆下降） " },
              { step: "3、再点击泄水阀的逆时针箭头符号，开启泄水阀（阀杆升起），并有水流出。 " },
              { step: "4、点击下一步。 " }

            ],
            warn: "",
          }
          break;


        case 6:
          if (this.radio == 0) {
            res = true;
          }
          break;
      }


      this.ansObj[this.activeKey] = res;

      if(this.ansObj[this.activeKey]){
        this.totalScore+=parseFloat(this.topic[this.activeKey]['score'])
      }
      let sorceObj = sessionStorage.getItem("sorceObj")? JSON.parse(sessionStorage.getItem("sorceObj")):[];
      sorceObj[this.apiId] = this.totalScore
      sessionStorage.setItem("sorceObj",JSON.stringify(sorceObj));
      console.log('分数',sorceObj)

      this.play2("select.mp3");

      if (this.activeKey < this.question.topic.length - 1) {
        this.activeKey = this.activeKey + 1;
        this.play(this.topic[this.activeKey][["audio"]]);
        this.play3(this.topic[this.activeKey][["loopAudio"]]);
        this.randomNum = this.topic[this.activeKey]["randomNum"];
        this.open = this.randomNum == 0 ? false : true;
        this.down = this.randomNum == 0 ? false : true;
        this.first = 1;


        //this.question['bg_img'] = url.src  
        if (this.activeKey == 1) {
          this.urls = this.question["tab"].filter((value, index, array) => {
            if (this.topic[this.activeKey]["tab"].indexOf(index) >= 0) {
              return array[index];
            }
          });
          this.question["bg_img"] = this.urls[0].src;
          this.topic[this.activeKey]["zoomIn"] = this.urls[0].zoomIn;
        }
        else if(this.activeKey==2){
          this.water=false;
          this.$refs.stable.auto=true;
          this.question["bg_img"] = this.topic[this.activeKey].background;
        }
        else {
          this.question["bg_img"] = this.topic[this.activeKey].background;
        }
      }
      else {
        sessionStorage.setItem("topic", JSON.stringify(this.topic));
        sessionStorage.setItem("ansObj", JSON.stringify(this.ansObj));
        let ids = sessionStorage.getItem('wids') ? JSON.parse(sessionStorage.getItem('wids')) : []
        ids.push(this.apiId)
        sessionStorage.setItem('wids', JSON.stringify(ids))
        setTimeout(() => {
          this.$router.replace("/result");
        }, 500);
        return true;
      }
      this.reset();
    },
    reset() {
      this.ckeckList = [];
      this.radio = null;
      this.print = false
      this.stableVisible = false;
      this.tipsVisible = false;
      this.frontVisible = false;
      this.pressVisible = false;
      this.enddeviceVisible = false;
      this.imgVisible = false;
      this.$refs.audio3.pause();
    },
    resetAll() {

      this.$refs.room.round = false
      this.$refs.room.halfround = false
      this.$refs.room.wrench1 = false
      this.$refs.room.wrench = false
      this.$refs.wind.trans = false
      this.$refs.wind.stop = false
      this.$refs.front.open = false
      this.$refs.front.turn = false
      this.$refs.front.inside = false
    },

    //
    // // 全面屏 

    fullscreen() {
      // 需要全屏显示的dom元素 
      let dom = this.$el.querySelector(".container");
      // 调用全屏方法
      this.$fullscreen.enter(dom, {
        wrap: false,
        callback: (f) => {
          this.fullscreenFlag = f;
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>

.container .toolbar {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 2.5rem;
  z-index: 9999;
}

.timer .time.hide {
  display: none;
}

.timer .time.show {
  display: block;
}

.handles.open {
  height: 100%;
}

.handles.close {
  height: 0;
}

.handled .handle.open {
  height: 5rem;
}

.handled .handle.close {
  height: 0;
}

.handled .handle.two {
  left: 3rem;
  bottom: 1.1rem;
}

.water {
  height: 100%;
  width: 100%;
  background: url(../../assets/img/water-2.png) no-repeat;
  position: relative;
  background-size: 100% 100%;
}

.water.show {
  display: block;
}

.water.hide {
  display: none;
}

.handled .handle {
  position: absolute;
  width: .6rem;
  height: 5rem;
  left: .3125rem;
  bottom: .1875rem;
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 100% 200%;
  -webkit-transition: height .5s linear;
  transition: height .5s linear;
}

.handles {
  height: 100%;
  width: 100%;
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 100% 100%;
  -webkit-transition: height .5s linear;
  transition: height .5s linear;
  position: absolute;
  bottom: 0;
}

.container .main .box {
  position: absolute;
  border: 2px solid green;
  cursor: pointer;
}

.timer .time .count {
  position: absolute;
  top: 39.7%;
  left: 21.477273%;
  height: 12.442922%;
  width: 60.454545%;
  font-family: DDD;
  font-size: 3.125rem;
  font-weight: 300;
  line-height: 70%;
  background-color: #aeb0b3;
}

.screen-comp.close {
  height: 2rem;
}

.screen-comp {
  background: url("https://bankaoedu.com/files/xc/chuibi-2.png") no-repeat;
  background-size: 100% auto;
  background-position: bottom;
  -webkit-transition: height 5s linear;
  transition: height 5s linear;
  height: 2rem;
}

.screen-comp.open {
  height: 15.75rem;
}

.open .window-cover-comp {
  -webkit-transform: rotateX(-45deg);
  transform: rotateX(-45deg);
}

.windows-comp .glass-comp,
.windows-comp {
  height: 100%;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.windows-comp {
  position: absolute;
  top: 0;
  left: 0;
}

.windows-comp .glass-comp {
  position: relative;
}

.windows-comp .glass-comp,
.windows-comp {
  height: 100%;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-frame-comp {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-perspective: 37.5rem;
  perspective: 37.5rem;
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-cover-comp {
  -webkit-transform-origin: bottom center;
  transform-origin: bottom center;
  bottom: 0;
}

.window-comp {
  width: 100%;
  top: 0;
  bottom: 0;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
  -webkit-transition: -webkit-transform 6s;
  transition: -webkit-transform 6s;
  transition: transform 6s;
  transition: transform 6s, -webkit-transform 6s;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 9999;
  -webkit-perspective: 800px;
  perspective: 800px;
  -webkit-box-shadow: inset -5px -5px 5px #000;
  box-shadow: inset -5px -5px 5px #000;
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-face-0-comp {
  background-color: rgba(0, 0, 0, 0.1);
  -webkit-transform: translateZ(-0.5rem);
  transform: translateZ(-0.5rem);
}

.window-face-0-comp,
.window-face-1-comp {
  left: -0.1875rem;
  top: -0.1875rem;
  right: -0.1875rem;
  bottom: -0.1875rem;
  border: 0.6rem solid #636e77;
  background-color: rgba(149, 227, 187, 0.1);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
  border-radius: 0;
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-face-2-comp {
  height: 0.5rem;
  left: -0.1875rem;
  right: -0.1875rem;
  top: 0;
  border: 0.1875rem solid #636e77;
  border-radius: 0;
  background-color: #636e77;
  -webkit-transform: translate3D(0, -0.4688rem, -0.1875rem) rotateX(90deg);
  transform: translate3D(0, -0.4688rem, -0.1875rem) rotateX(90deg);
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-face-1-comp {
  -webkit-transform: translateZ(0);
  transform: translateZ(-35);
}

.window-face-0-comp,
.window-face-1-comp {
  left: -0.1875rem;
  top: -0.1875rem;
  right: -0.1875rem;
  bottom: -0.1875rem;
  border: 0.6rem solid #636e77;
  background-color: rgba(149, 227, 187, 0.1);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
  border-radius: 0;
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-face-3-comp {
  width: 0.375rem;
  top: -0.1875rem;
  right: 0;
  bottom: -0.1875rem;
  border: 0.1875rem solid #636e77;
  border-radius: 0;
  background-color: #636e77;
  -webkit-transform: translate3D(0.4688rem, 0, -0.1875rem) rotateY(90deg);
  transform: translate3D(0.4688rem, 0, -0.1875rem) rotateY(90deg);
}

.windows-comp .glass-comp div {
  position: absolute;
}

.window-face-4-comp {
  height: 0.375rem;
  left: -0.1875rem;
  right: -0.1875rem;
  bottom: 0;
  border: 0.1875rem solid #636e77;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3D(0, 0.4688rem, -0.1875rem) rotateX(90deg);
  transform: translate3D(0, 0.4688rem, -0.1875rem) rotateX(90deg);
}

.question {
  position: relative;
  height: 100%;
  width: 100%;
  // ======
}

// .main-container {
//   width: 100%;
//   height: 100%;
//   transition: margin-left 0.28s;
//   margin-left: 0;
//   position: relative;
//   background: #f8f8f8;
// }
.main-container {
  min-height: 100%;
  transition: margin-left 0.28s;
  margin-left: 0;
  position: relative;
  background: #f8f8f8;
}

.app-main {
  position: relative;
}

.container {
  // 全屏下
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  position: relative;
  // 非全屏下
  //   width: 120rem;
  // height: 67.5rem;
  // margin: 0 auto;
  // position: relative;

  .main-background {
    position: absolute;
    inset: 0 0 0 0;
    z-index: 0;
    overflow: hidden;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    // width: 100%;
    // height: 100%;
  }

  .title {
    height: 2.5rem;
    background-color: #409eff;
    line-height: 2.5rem;
    color: #fff;
    font-weight: 500;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    z-index: 8;
    left: 0;
    top: 0;
    width: 100%;
    font-size: 2rem;

    .ct {
      margin-left: auto;
    }
  }

  .main {
    position: relative;
    height: 100%;
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    box-sizing: border-box;
    background-attachment: fixed;

    .zoom {
      position: absolute;
      cursor: pointer;

      img {
        width: 2.5rem;
        height: 2.5rem;
      }
    }

    .sub-title {
      height: 2.5rem;
      background-color: #fff;
      padding: 0 1.25rem;
      position: absolute;
      z-index: 8;
      left: 0;
      top: 2.5rem;
      width: 100%;
      font-size: 1.5rem;

      .progress {
        font-size: 0.875rem;

        span {
          font-size: 0.8125rem;
          margin: 0 0.3125rem;
        }
      }
    }

    // 选这题
    .choose {
      position: absolute;
      left: 1.25rem;
      top: 6.25rem;
      min-width: 12.5rem;
      max-width: 21.875rem;
      background-color: #409eff;
      z-index: 99999;
      border-radius: 0.625rem;
      box-shadow: 1px 1px 5px #ccc;
      box-sizing: border-box;

      .choose-title {
        color: #fff;
        padding: 0.625rem;
        font-size: 1.5rem;
      }

      .choose-option {
        background-color: #fff;
        padding: 1.25rem 0.625rem;
        border-radius: 0 0 0.625rem 0.625rem;

        .option {
          margin-bottom: 1.25rem;
          font-size: 1.5rem;
        }
      }
    }
  }

  //   按钮
  .toolba {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 2.5rem;
    z-index: 9999;
  }

  .toolbar-content {
    margin: 0 12.5rem;

    .right-btn {
      margin-left: auto;
    }

    button {
      padding: 0.625rem 1.875rem;
      color: #fff;
      font-size: 16px;
      margin: 0 1.875rem;
      border-radius: 0.3125rem;
      cursor: pointer;
    }
  }

  .toolbar-content .btns,
  .toolbar-content .right-btn {
    display: flex;
    align-items: center;
  }

  .toolbar-content .btns {
    position: absolute;
    z-index: 9999;
    left: 6.25rem;
    right: 6.25rem;
    bottom: 0;
  }
}

.container .main .sub-title .progress,
.container .main .sub-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// 屏幕</style>
